import { Middleware } from '@reduxjs/toolkit';

import {
  CALENDAR_HIDE_COMPLETED_KEY,
  CALENDAR_VIEW_KEY,
  setCalendarView,
  toggleCalendarHideCompleted,
} from './calendar';
import {
  HIDE_COMPLETED_KEY,
  TIMEFRAME_FILTER_KEY,
  clearFilters,
  setTimeframeFilter,
  toggleHideCompleted,
} from './home';
import { RootState } from './types';

export const homeFiltersLocalStorageMiddleware: Middleware<object, RootState> =
  (store) => (next) => (action) => {
    const result = next(action);
    if (toggleHideCompleted.match(action)) {
      try {
        const state = store.getState();
        localStorage.setItem(
          HIDE_COMPLETED_KEY,
          JSON.stringify(state.home.filters.hideCompleted)
        );
      } catch (error) {
        console.warn('Failed to set home filter state in local storage', error);
      }
    }
    if (setTimeframeFilter.match(action) || clearFilters.match(action)) {
      try {
        const state = store.getState();
        localStorage.setItem(
          TIMEFRAME_FILTER_KEY,
          JSON.stringify(state.home.filters.timeframe)
        );
      } catch (error) {
        console.warn('Failed to set home filter state in local storage', error);
      }
    }
    return result;
  };

export const calendarLocalStorageMiddleware: Middleware<object, RootState> =
  (store) => (next) => (action) => {
    const result = next(action);
    if (toggleCalendarHideCompleted.match(action)) {
      try {
        const state = store.getState();
        localStorage.setItem(
          CALENDAR_HIDE_COMPLETED_KEY,
          JSON.stringify(state.calendar.filters.hideCompleted)
        );
      } catch (error) {
        console.warn(
          'Failed to set calendar filter state in local storage',
          error
        );
      }
    }
    if (setCalendarView.match(action)) {
      try {
        const state = store.getState();
        localStorage.setItem(CALENDAR_VIEW_KEY, state.calendar.view);
      } catch (error) {
        console.warn('Failed to set calendar view in local storage', error);
      }
    }
    return result;
  };
